<app-simple-modal-header
	[pageTitle]="mode + ' ' + pageTitle"
	(dismissed)="dismiss()"
></app-simple-modal-header>

<ion-content>
	<form [formGroup]="form" *ngIf="form">
		<ion-list lines="full">
			<ion-item *ngIf="!isHidden('appointment')">
				<ion-label position="stacked">Appointment</ion-label>
				<ion-select
					placeholder="Select"
					[interfaceOptions]="{ header: 'Appointment' }"
					[compareWith]="formHelper.compareWith"
					[formControl]="form.controls.appointment"
					(ionChange)="onChangeAppointment($event.detail.value)"
				>
					<ion-select-option [value]="appointmentOptionDefault">
						{{ appointmentOptionDefault.displayValue }}
					</ion-select-option>
					<ion-select-option
						*ngFor="let appointment of appointmentOptions"
						[value]="appointment"
					>
						{{ appointment.displayValue }}
					</ion-select-option>
				</ion-select>
			</ion-item>
			<ion-item>
				<ion-label position="stacked">Time Code:</ion-label>
				<ion-select
					[formControl]="form.controls.timeCode"
					[compareWith]="formHelper.compareWith"
					[value]="form.controls.timeCode.value"
				>
					<ion-select-option
						*ngFor="let timeCode of timeCodeOptions"
						[value]="timeCode"
					>
						{{ timeCode.desc }}
					</ion-select-option>
				</ion-select>
			</ion-item>
			<ion-item>
				<ion-label position="stacked">Pay Code:</ion-label>
				<ion-select
					[formControl]="form.controls.payCode"
					[compareWith]="formHelper.compareWith"
				>
					<ion-select-option
						*ngFor="let payCode of payCodeOptions"
						[value]="payCode"
					>
						{{ payCode.desc }}
					</ion-select-option>
				</ion-select>
			</ion-item>
			<ion-item *ngIf="canShowServiceDropDown()">
				<ion-label position="stacked">Service:</ion-label>
				<ion-select
					[formControl]="form.controls.service"
					[compareWith]="formHelper.compareWith"
					[value]="form.controls.service.value"
				>
					<ion-select-option [value]="serviceOptionDefault">
						{{ serviceOptionDefault.desc }}
					</ion-select-option>
					<ion-select-option
						*ngFor="let service of serviceOptions"
						[value]="service"
					>
						{{ service.desc }}
					</ion-select-option>
				</ion-select>
			</ion-item>
			<ion-item>
				<ion-label position="stacked">Duration: (hh:mm)</ion-label>
				<ion-input id="open-time"
						   [value]="form.controls.time.value"
						   readonly="true"></ion-input>
				<ion-popover trigger="open-time" show-backdrop="true">
					<ng-template>
							<ion-datetime presentation="time" hourCycle="h23" [showDefaultButtons]="true"
										  [formControl]="form.controls.time">
							</ion-datetime>
					</ng-template>
					</ion-popover>
			</ion-item>
			<ion-item>
				<ion-label position="stacked">Capital:</ion-label>
				<ion-select
					placeholder="Select One"
					[formControl]="form.controls.capital"
				>
					<ion-select-option [value]="true">Yes</ion-select-option>
					<ion-select-option [value]="false">No</ion-select-option>
				</ion-select>
			</ion-item>
			<ion-item>
				<ion-label position="stacked">Note</ion-label>
				<ion-textarea
					[formControl]="form.controls.note"
					name="note"
					rows="4"
				></ion-textarea>
			</ion-item>
		</ion-list>
	</form>
</ion-content>

<ion-footer>
	<ion-button
		expand="full"
		class="modal__submit"
		(click)="onClickTimeEntry()"
	>
		{{ mode === "Add" ? "Add" : "Save" }} Time Entry
	</ion-button>
</ion-footer>
